
import moment from 'moment';
function deepCleanTracking(tr) {
  let result = `### ${moment(tr.dataDate).format('YYYY/MM/DD')} [${tr.inputorName || '未指定'}] ${tr.issue?(tr.status == 1?'[已闭合]':'[需要整改]'):''}${tr.trackingDetail ? '\n   '+tr.trackingDetail:''}`;
  if (tr.fileURL) {
    result += `\n -- 附件:${tr.fileURL}`;
  }
  if (tr.jsd) {
    const jsd = JSON.parse(tr.jsd);
    if(jsd && Array.isArray(jsd.content) && jsd.content.length > 0) {
      result += `\n -- 跟踪表单:${jsd.title}\n`;
      result += jsd.content.map((content)=>{
        let c = ` 【${content.title || content.category}】\n`;
        if (content.items && content.items.length > 0) {
          c += content.items.map((item)=>{
            if (item.formType =='signature' && item.fileURL) {
              item.value = item.fileURL;
              return `  ${item.title} : [${item.value || '无'}]`;
            }
  
            let itemStr = `  ${item.title} : [${item.value || '无'}]`;
            if (item.note) {
              itemStr += `\n 情况说明: ${item.note}`;
            }
            if (item.fileURL) {
              itemStr += '\n  '+item.fileURL;
            }
            return itemStr;
          }).join('\n') + '\n';
        }
  
        return c;
      }).join('');
    }
      
      
  
  }

  if (tr.comments && tr.comments.length > 0) {
    result += '\n -- 回复内容:\n';
    result += tr.comments.map((c)=>{
      return `[类型:${c.classify}] ${moment(c.inputDate).format('YYYY/MM/DD HH:mm')} [${c.inputorName}] ${c.content}`;
    }).join('\n');
  }

  if (tr.archives && tr.archives.length > 0) {
    result += '\n -- 附件:\n';
    result += tr.archives.map((c)=>{
      let jsc = c.jsc;
      let str = `[${c.archiveClassify}] ${c.inputDate}\n`;
      if (c.jsc) {
        jsc = JSON.parse(jsc);
        str += `  [${jsc.dataType}] 检查点:${jsc.position || '无'}`;
      }
      return str;
    }).join('\n');
  }

  return result;
}

function zipForm(jsd, eformmap) {

}

function deepCleanTask(task, startDate, endDate, uid, eformmap, onlyQuestion, hideEmptyTracking, omitTracking, simpleMode) {
  let shortIndex = 1;
  let result = `任务名称 ${task.jobNode || task.node}\n`;
  if (task.jobNodeDesc) {
    result += `## 描述 ${task.jobNodeDesc}\n`;
  }
  if (task.notes) {
    result += `## 备注 ${task.notes}\n`;
  }
  if (task.ref) {
    result += `## 作业指导 ${task.ref.jobManual}\n`;
  }
  if (task.startDate) {
    result += `## 开始日期 ${task.startDate?moment(task.startDate).format('YYYY/MM/DD'):''}\n`;
  }
  if (task.dueDate) {
    result += `## 截止日期 ${task.dueDate?moment(task.dueDate).format('YYYY/MM/DD'):''}\n`;
  }
  result += `## 状态 ${task.status==1?'已完成':'进行中'}\n`;
  if (task.finishDate) {
    result += `## 完成日期 ${task.finishDate?moment(task.finishDate).format('YYYY/MM/DD'):''}\n`;
  }
  if (omitTracking) {
    return result;
  }
  if (!task.trackings || !Array.isArray(task.trackings)) {
    return result;
  }
  const filteredTrackings = task.trackings.filter((tr)=>{
    if (uid && tr.inputor != uid) return false;

    // 如果没有提供日期筛选条件，返回所有记录
    if (!startDate && !endDate) return true;

    // 确保记录有日期
    if (!tr.dataDate) return false;

    const trackingDate = moment(tr.dataDate);

    // 如果有开始日期，检查记录日期是否大于等于开始日期
    if (startDate && moment(startDate).isValid()) {
      if (trackingDate.isBefore(moment(startDate))) return false;
    }

    // 如果有结束日期，检查记录日期是否小于等于结束日期
    if (endDate && moment(endDate).isValid()) {
      if (trackingDate.isAfter(moment(endDate))) {
        return false;
      }
    }

    // 通过所有筛选条件
    return true;
  });

  const ingored = ['符合', '/', '未见异常', '未发现', '无', '现阶段未涉及', '未发现风险', '现阶段未涉', '未发现'];
  if (filteredTrackings.length > 0) {
    result += `## 跟踪记录(${filteredTrackings.length})`;
    filteredTrackings.forEach((tr)=>{
      result += `\n### ${moment(tr.dataDate).format('YYYY/MM/DD')} [${tr.inputorName || '未指定'}] ${tr.issue?(tr.status == 1?'[已闭合]':'[需要整改]'):''}${tr.trackingDetail ? '\n   '+tr.trackingDetail:''}`;
      if (tr.fileURL) {
        result += `\n -- 附件:${tr.fileURL}`;
      }
      if (tr.jsd) {
        const jsd = JSON.parse(tr.jsd);

        if (eformmap) {
          if (!eformmap[jsd.title]) {
            eformmap[jsd.title] = jsd;
          }
          result += `\n -- 跟踪表单:${jsd.title}\n`;
          if(jsd && Array.isArray(jsd.content) && jsd.content.length > 0) {

            result += jsd.content.map((content)=>{
              let c = ``;
              if (content.items && content.items.length > 0) {
                let content_items = content.items.map((item)=>{
                  if (item.formType =='signature' && item.fileURL) {
                    item.value = item.fileURL;
                    return `  ${item.title}:[${item.value || '/'}]`;
                  }
  
                  let itemStr = `  ${item.title} : [${item.value || '无'}]`;
  
                  if (item.note) {
                    itemStr += `\n 情况说明: ${item.note}`;
                  }
                  if (item.fileURL) {
                    itemStr += `\n  附件`+item.fileURL;
                  }
                  if (onlyQuestion && !item.note && (!item.value || ingored.includes(item.value))) {
                    itemStr = '';
                  }
                  
                  if(simpleMode && unnormal.includes(item.value)==false){
                    itemStr = ''
                  }
                  return itemStr;
                })
                if(content_items.length == 0)
                  return c
                
                c += content_items.join('\n') + '\n';
              }
  
              return c;
            }).filter(v=>v).join('');
          }
          
        } else {
          result += `### 表单:${jsd.title}\n`;
          if(jsd && Array.isArray(jsd.content) && jsd.content.length > 0) {
            result += jsd.content.map((content)=>{
              let c = ` 【${content.title || content.category}】\n`;
              if (content.items && content.items.length > 0) {
                // c += content.items.map((item)=>{
                //   if (item.formType =='signature' && item.fileURL) {
                //     item.value = item.fileURL;
                //     return `  ${item.title}:[${item.value || '/'}]`;
                //   }
  
                //   let itemStr = `  ${item.title} : [${item.value || '无'}]`;
  
                //   if (item.note) {
                //     itemStr += `\n 情况说明: ${item.note}`;
                //   }
                //   if (item.fileURL) {
                //     itemStr += '\n  '+item.fileURL;
                //   }
                //   if (onlyQuestion && !item.note && (!item.value || ingored.includes(item.value))) {
                //     itemStr = '';
                //   }
                //   return itemStr;
                // }).join('\n') + '\n';
              
                let content_items = content.items.map((item)=>{
                  if (item.formType =='signature' && item.fileURL) {
                    item.value = item.fileURL;
                    return `  ${item.title}:[${item.value || '/'}]`;
                  }
  
                  let itemStr = `  ${item.title} : [${item.value || '无'}]`;
  
                  if (item.note) {
                    itemStr += `\n 情况说明: ${item.note}`;
                  }
                  if (item.fileURL) {
                    itemStr += `\n  附件`+item.fileURL;
                  }
                  if (onlyQuestion && !item.note && (!item.value || ingored.includes(item.value))) {
                    itemStr = '';
                  }
                  
                  if(simpleMode && unnormal.includes(item.value)==false){
                    itemStr = ''
                  }
                  return itemStr;
                })
                if(content_items.filter(v=>v).length == 0)
                  return null
                
                c += content_items.filter(v=>v).join('\n') + '\n';
  
              }
  
              return c;
            }).join('');
          }
          }
          
      }

      if (tr.comments && tr.comments.length > 0) {
        result += '\n -- 回复内容:\n';
        result += tr.comments.map((c)=>{
          return `[类型:${c.classify}] ${moment(c.inputDate).format('YYYY/MM/DD HH:mm')} [${c.inputorName}] ${c.content}`;
        }).join('\n');
      }

      if (!simpleMode && tr.archives && tr.archives.length > 0) {
        result += '\n -- 附件:\n';
        result += tr.archives.map((c)=>{
          let jsc = c.jsc;
          let str = `[${c.archiveClassify}] ${c.inputDate}\n`;
          if (c.jsc) {
            jsc = JSON.parse(jsc);
            str += `  [${jsc.dataType}] 检查点:${jsc.position || '无'}`;
          }
          return str;
        }).join('\n');
      }
    });
  } else {
    if (task.splits && task.splits.length > 0) {
      result += `\n## 任务分解  (${task.splits.length}) 个子任务\n`;
      const active_splits = task.splits.map((t, i)=>{
        const substr = deepCleanTask(t, startDate, endDate, uid, eformmap, onlyQuestion, hideEmptyTracking, omitTracking);
        if (substr) {
          return `*** 子任务${i+1} ** \n${substr}`;
        }
      }).filter((v)=>v);
      if (active_splits.length > 0) {
        result += `\n## 跟踪动态 (${active_splits.length}) 个子任务\n`;
        result += active_splits.join('\n');
        if (hideEmptyTracking) {
          return result;
        }
      } else {
        result += `\n## 跟踪动态:无`;
      }
    }

    if (hideEmptyTracking) {
      return '';
    } else {
      return result;
    }
  }


  return result;
}


function renderEFormMap(eformmap) {
  let formstrs = `以下为数据中使用的表格类型`;
  if (Object.keys(eformmap).length == 0) {
    formstrs = '';
  }
  Object.keys(eformmap).map((k)=>{
    const jsd = eformmap[k];
    formstrs += `\n## 表格:${jsd.title}\n`;
    formstrs += jsd.content.map((content)=>{
      let c = ` 【${content.title || content.category}】\n`;
      if (content.items && content.items.length > 0) {
        c += content.items.map((item)=>{
          if (item.formType =='signature' && item.fileURL) {
            item.value = item.fileURL;
            return `  ${item.title}:[${item.name}]`;
          }

          const itemStr = `  ${item.title} : [${item.name}]`;

          return itemStr;
        }).join('\n') + '\n';
      }

      return c;
    }).join('');
  });
  return formstrs;
}

function extractAttachments(taskText) {
  // 提取文本中的URL，将图片和文件分别存储，并替换原文本中的URL

  // 修改URL正则表达式，确保不包含逗号
  // 匹配http或https开头的URL，或以/开头并以特定文件扩展名结尾的路径
  // 使用负向前瞻(?!,)确保不匹配逗号
  const urlRegex = /(https?:\/\/[^\s,]+|\/[^\s,]+\.(jpeg|jpg|png|gif|bmp|webp|pdf|docx|doc|xlsx|xls|pptx|ppt|txt|zip|rar|dwg|exe))/gi;
  const images = [];
  const files = [];
  let newText = taskText;

  // 查找所有匹配的URL
  const matches = taskText.match(urlRegex);
  if (matches) {
    matches.forEach((url) => {
      // 判断URL是否为图片
      const isImage = /\.(jpeg|jpg|png|gif|bmp|webp)$/i.test(url);

      if (isImage) {
        // 添加到图片数组

        // 替换原文本中的URL为[图片i]
        newText = newText.replace(url, `[图片${images.length + 1}]`);
        if (url.startsWith('http') == false) {
          url = 'https://www.gaozhuan.net' + url;
        }
        images.push(url);
      } else {
        // 添加到文件数组
        // 替换原文本中的URL为[附件i]
        newText = newText.replace(url, `[附件${files.length}]`);
        if (url.startsWith('http') == false) {
          url = 'https://www.gaozhuan.net' + url;
        }
        files.push(url);
      }
    });
  }
  newText = newText.replace(/(\n)+/g, '\n');

  return {text: newText, files, images};
}


const unnormal = ['否','不符合','存在问题','存在异常','不合格','存在问题，详见整改记录','存在重大事故隐患'];

function deepCleanTaskAI(task, startDate, endDate, uid,   eformmap, onlyQuestion, hideEmptyTracking, simpleMode) {
  let shortIndex = 1;
  let result = `任务ID ${task.fID || task.nID}\n任务名称 ${task.jobNode || task.node}\n`;
  if (task.jobNodeDesc) {
    result += `## 描述 ${task.jobNodeDesc}\n`;
  }
  if (task.notes) {
    result += `## 备注 ${task.notes}\n`;
  }
  if (task.ref) {
    result += `## 作业指导 ${task.ref.jobManual}\n`;
  }
  if (task.startDate) {
    result += `## 开始日期 ${task.startDate?moment(task.startDate).format('YYYY/MM/DD'):''}\n`;
  }
  if (task.dueDate) {
    result += `## 截止日期 ${task.dueDate?moment(task.dueDate).format('YYYY/MM/DD'):''}\n`;
  }
  result += `## 状态 ${task.status==1?'已完成':'进行中'}\n`;
  if (task.finishDate) {
    result += `## 完成日期 ${task.finishDate?moment(task.finishDate).format('YYYY/MM/DD'):''}\n`;
  }
  if (!task.trackings || !Array.isArray(task.trackings)) {
    return result;
  }
  const filteredTrackings = task.trackings.filter((tr)=>{
    if (uid && tr.inputor != uid) return false;

    // 如果没有提供日期筛选条件，返回所有记录
    if (!startDate && !endDate) return true;

    // 确保记录有日期
    if (!tr.dataDate) return false;

    const trackingDate = moment(tr.dataDate);

    // 如果有开始日期，检查记录日期是否大于等于开始日期
    if (startDate && moment(startDate).isValid()) {
      if (trackingDate.isBefore(moment(startDate))) return false;
    }

    // 如果有结束日期，检查记录日期是否小于等于结束日期
    if (endDate && moment(endDate).isValid()) {
      if (trackingDate.isAfter(moment(endDate))) {
        return false;
      }
    }

    // 通过所有筛选条件
    return true;
  });

  const ingored = ['符合', '/', '未见异常', '未发现', '无', '现阶段未涉及', '未发现风险', '现阶段未涉', '未发现'];
  
  if (filteredTrackings.length > 0) {
    result += `## 跟踪记录(${filteredTrackings.length})`;
    filteredTrackings.forEach((tr)=>{
      result += `\n### ${moment(tr.dataDate).format('YYYY/MM/DD')} [${tr.inputorName || '未指定'}] ${tr.issue?(tr.status == 1?'[已闭合]':'[需要整改]'):''}${tr.trackingDetail ? '\n   '+tr.trackingDetail:''}`;
      if (tr.fileURL) {
        result += `\n -- 附件:${tr.fileURL}`;
      }
      if (tr.jsd) {
        const jsd = JSON.parse(tr.jsd);

        if (eformmap) {
          if (!eformmap[jsd.title]) {
            eformmap[jsd.title] = jsd;
          }
          result += `\n -- 跟踪表单:${jsd.title}\n`;
          result += jsd.content.map((content)=>{
            let c = ``;
            if (content.items && content.items.length > 0) {
              c += content.items.map((item)=>{
                if (item.name && item.name.length > 4) {
                  item.name = 'rp' + (shortIndex++);
                }
                if (item.formType =='signature' && item.fileURL) {
                  item.value = item.fileURL;
                  return `  ${item.name} : [${item.value || '/'}]`;
                }

                let itemStr = `  ${item.name} : [${item.value || '无'}]`;
                if (item.note) {
                  itemStr += `\n 情况说明: ${item.note}`;
                }
                if (item.fileURL) {
                  itemStr += '\n  '+item.fileURL;
                }
                if (onlyQuestion && !item.note && (!item.value || ingored.includes(item.value))) {
                  itemStr = '';
                }
                
                if(simpleMode && unnormal.includes(item.value)==false){
                  itemStr = ''
                }
                return itemStr;
              }).join('\n') + '\n';
            }

            return c;
          }).join('');
        } else {
          result += `### 表单:${jsd.title} - id(${tr.fID})\n`;
          result += jsd.content.map((content)=>{
            let c = `【${content.title || content.category}】\n`;
            if (content.items && content.items.length > 0) {
              let content_items = content.items.map((item)=>{
                if (item.formType =='signature' && item.fileURL) {
                  item.value = item.fileURL;
                  return `  ${item.title}:[${item.value || '/'}]`;
                }

                let itemStr = `  ${item.title} : [${item.value || '无'}]`;

                if (item.note) {
                  itemStr += `\n 情况说明: ${item.note}`;
                }
                if (item.fileURL) {
                  itemStr += `\n  附件`+item.fileURL;
                }
                if (onlyQuestion && !item.note && (!item.value || ingored.includes(item.value))) {
                  itemStr = '';
                }
                console.log('simpleMode:',simpleMode, item.value, unnormal.includes(item.value));
                if(simpleMode && unnormal.includes(item.value)==false){
                  itemStr = ''
                }
                return itemStr;
              })

              if(content_items.join('') === '')
                return ''

              if(content_items.length == 0)
                return c
              
              c += content_items.join('\n') + '\n';
            }

            if (content.fileURL) {
              c += `\n 分组附件:${content.fileURL}`;
            }
            return c;
          }).join('');
        }
      }
      if (tr.comments && tr.comments.length > 0) {
        result += '\n -- 回复内容:\n';
        result += tr.comments.map((c)=>{
          return `[类型:${c.classify}] ${moment(c.inputDate).format('YYYY/MM/DD HH:mm')} [${c.inputorName}] ${c.content}`;
        }).join('\n');
      }

      if (!simpleMode && tr.archives && tr.archives.length > 0) {
        result += '\n -- 记录附件:\n';
        result += tr.archives.map((c)=>{
          let jsc = c.jsc;
          let str = ` -- [${c.archiveClassify}] ${c.inputDate}\n`;
          if (c.jsc) {
            jsc = JSON.parse(jsc);
            str += ` -- [${jsc.dataType}] 检查点:${jsc.position || '无'}`;
          }
          return str;
        }).join('\n');
      }
    });
  } else {
   
  }

  if (task.splits && task.splits.length > 0) {
    result += `\n## 任务分解  (${task.splits.length}) 个子任务\n`;
    const active_splits = task.splits.map((t, i)=>{
      const substr = deepCleanTask(t, startDate, endDate, uid, eformmap, onlyQuestion, hideEmptyTracking, false, simpleMode);
      if (substr) {
        return `*** 子任务${i+1} ** \n${substr}`;
      }
    }).filter((v)=>v);
    if (active_splits.length > 0) {
      result += `\n## 跟踪动态 (${active_splits.length}) 个子任务\n`;
      result += active_splits.join('\n');
      if (hideEmptyTracking) {
        return result;
      }
    } else {
      result += `\n## 跟踪动态:无`;
    }
  }

  if (hideEmptyTracking) {
    return '';
  } else {
    return result;
  }


  return result;
}


function clearTasks(tasks, started_at, finished_at) {
  let taskdata = tasks.map((t)=>deepCleanTaskAI(t, started_at, finished_at, null, null, true, true, null, null, null, true)).join('\n');
  taskdata = taskdata.replace(/(\n)+/g, '\n');
  return taskdata;
}

module.exports = {
  deepCleanTracking,
  deepCleanTask,
  clearTasks,
  renderEFormMap,
  extractAttachments,
};
